module.exports = __webpack_public_path__ + "static/media/text_search.ea912855.svg";